export default __webpack_public_path__ + "static/media/appointment-bg.eb42256e.png";